module.exports = __webpack_public_path__ + "static/controleur-wifi-d7902cae67c8fbdd44b390d71465da75.webm";